<div *ngFor="let message of validationMessages" 
     [class]="className || 'field-validation-message'">
  <ng-container *ngIf="message.key; else plainMessage">
    {{ message.key | translate: message.params }}
  </ng-container>
  <ng-template #plainMessage>
    {{ message | translate }}
  </ng-template>
</div>
